/* Step 4 — Delivery (informational).
 *
 * Simple overview of available delivery methods (Email, WhatsApp, Share).
 * No form fields. This page fits on one screen.
 */

export const step4 = {
  key: 'delivery',
  title: 'Delivery',

  render(container) {
    container.innerHTML = `
      <div class="gc-step gc-step-delivery">
        <div class="gc-step-heading">
          <h2 class="gc-step-title">Delivery Methods</h2>
          <p class="gc-step-sub">Choose how to send your card after checkout.</p>
        </div>

        <ul class="gc-delivery-list">
          <li class="gc-delivery-item">
            <div class="gc-delivery-item-head">
              <span class="gc-delivery-icon">${ICON.email}</span>
              <strong class="gc-delivery-item-title">Email</strong>
              <span class="gc-pill">SEND NOW OR SCHEDULE</span>
            </div>
            <p class="gc-delivery-item-desc">Send the card immediately or pick a specific date and time.</p>
          </li>
          <li class="gc-delivery-item">
            <div class="gc-delivery-item-head">
              <span class="gc-delivery-icon gc-icon-whatsapp">${ICON.whatsapp}</span>
              <strong class="gc-delivery-item-title">WhatsApp</strong>
              <span class="gc-pill">DIRECT SHARE</span>
            </div>
            <p class="gc-delivery-item-desc">Send straight to a contact from your phone.</p>
          </li>
          <li class="gc-delivery-item">
            <div class="gc-delivery-item-head">
              <span class="gc-delivery-icon">${ICON.share}</span>
              <strong class="gc-delivery-item-title">Share link</strong>
              <span class="gc-pill">COPY OR SOCIAL</span>
            </div>
            <p class="gc-delivery-item-desc">Copy the link or share to Facebook, Instagram, TikTok, Snapchat, or your favourite app.</p>
          </li>
        </ul>
      </div>`;
  },

  validate() { return { ok: true }; },

  nextLabel() { return 'Next: Review'; }
};

const ICON = {
  email: `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>`,
  whatsapp: `<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" focusable="false"><path d="M20.5 3.5A10.5 10.5 0 0 0 3.7 16.3L2.5 21l4.8-1.2A10.5 10.5 0 1 0 20.5 3.5Zm-8.4 16.1a8.7 8.7 0 0 1-4.4-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.7 8.7 0 1 1 12.1 19.6Zm4.8-6.5c-.3-.1-1.6-.8-1.8-.9-.2-.1-.4-.1-.6.1-.2.3-.7.9-.8 1-.2.2-.3.2-.6.1a7 7 0 0 1-2.1-1.3 8 8 0 0 1-1.5-1.8c-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.8-2c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.4a3 3 0 0 0-1 2.3c0 1.3 1 2.6 1.1 2.7.2.2 2 3 4.8 4.2 1.7.7 2.3.8 3.1.7.5-.1 1.6-.7 1.8-1.3.2-.6.2-1.1.2-1.3 0-.1-.2-.2-.5-.4Z"/></svg>`,
  share: `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5 15.4 17.5"/><path d="M15.4 6.5 8.6 10.5"/></svg>`
};
